// 处理noChangeAspect
import { LocksAttributes } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';
import NoChangeAspectType from '@src/slide/domain/ui-model/element-modeles/property/lock/size-style-type';

export const getNoChangeAspectType = (locks) => {
    const noChangeAspect = locks?.[LocksAttributes.NO_CHANGE_ASPECT];
    if (noChangeAspect) {
        return NoChangeAspectType.NO_CHANGE_ASPECT;
    }
    return NoChangeAspectType.CHANGE_ASPECT;
};
